<template>
  <div class="app-container">
    <div style="padding: 5px 0">
      <el-select v-model="params.showType" @change="change">
        <el-option label="销售订单" :value="0"></el-option>
        <el-option label="设备" :value="1"></el-option>
      </el-select>
    </div>
    <div ref="ganttContainer" style="width: 100%; height: 600px"></div>
   
    <div style="padding: 5px 0"> <el-pagination
      background
      style="float: right;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageParams.pageIndex"
      :page-sizes="[15, 30, 50, 100]"
      :page-size="pageParams.pageSize"
      layout="sizes, prev, pager, next, total, jumper"
      :total="total"
    >
    </el-pagination></div>
  </div>
</template>
<script>
import 'dhtmlx-gantt/codebase/dhtmlxgantt.css'

import { gantt } from 'dhtmlx-gantt'

export default {
  name: 'gantetu',
  components: {},
  data() {
    return {
      api: require('@/api/sa/saOrder').default,
      params: {
        showType: null
      },
      total: 0,
      pageParams: {
        pageSize: this.pageSize || this.$store.state.sys.pageSize, //分页大小
        pageIndex: 1
      },
      tasks: {
        data: [],
        links: [] // 任务依赖关系
      },
      data: [
        {
          id: 1,
          text: 'A组',
          desc: '浸染',
          start_date: new Date('2025-08-07 00:00:00'),
          unit: '天',
          duration: 6,
          progress: 0.7,
          open: true
        },
        {
          id: 2,
          text: 'B组',
          desc: '裁剪',
          start_date: new Date('2025-08-09 00:00:00'),
          unit: '天',
          duration: 3,
          progress: 0.3
        },
        {
          id: 3,
          text: 'C组',
          desc: '机加工',
          start_date: new Date('2025-08-06 12:00:00'),
          unit: '天',
          duration: 2,
          progress: 0.9
        },
        {
          id: 4312,
          text: '调机',
          desc: '调机',
          start_date: new Date('2025-08-07 00:00:00'),
          unit: '天',
          duration: 2,
          progress: 1,
          parent: 1
        },
        {
          id: 5121,
          text: '加工',
          desc: '加工',
          start_date: new Date('2025-08-12 22:00:00'),
          unit: '天',
          duration: 4,
          progress: 0.6,
          parent: 1
        }
      ]
    }
  },
  mounted() {
    // 动态设置高度
    this.$refs.ganttContainer.style.height = window.innerHeight - 53 + 'px'
    // this.tasks.data = this.data
    // gantt.parse(this.tasks)
    // gantt.refreshData()
    this.initGantt()
  },
  methods: {
    handleSizeChange(val) {
      this.pageParams.pageSize = val
      this.change(this.params.showType)
    },
    handleCurrentChange(val) {
      this.pageParams.pageIndex = val
      this.change(this.params.showType)
    },
    change(val) {
      gantt.clearAll()
      this.tasks.data = []
      gantt.parse(this.tasks)
      gantt.render()

      if (val == 0) {
        gantt.config.columns = [
          { name: 'text', label: '产品名称', min_width: 220, tree: true },
          { name: 'orderNo', label: '销售订单号', min_width: 100, align: 'center' },
          { name: 'workDocNo', label: '工单号', min_width: 100, align: 'center' },
          { name: 'StockInQuantity', label: '已入库数', min_width: 100, align: 'center' },
          { name: 'UnStockInQuantity', label: '未入库数', min_width: 100, align: 'center' }
        ]
        this.api.gantetuList(this.pageParams).then(res => {
          this.tasks.data = res.Data
          this.total = res.Count
          this.tasks.data.forEach(item => {
            item.start_date = new Date(item.start_date)
          })
          gantt.parse(this.tasks)
          gantt.refreshData()
          gantt.render()
        })
      } else if (val == 1) {
        gantt.config.columns = [
          { name: 'text', label: '设备名称',tree: true, min_width: 120 },
          { name: 'workDocNo', label: '工单号', min_width: 100, align: 'center' },
          { name: 'StockInQuantity', label: '已入库数', min_width: 100, align: 'center' },
          { name: 'UnStockInQuantity', label: '未入库数', min_width: 100, align: 'center' }]
        this.api.gantetuList2(this.pageParams).then(res => {
          this.tasks.data = res.Data
          this.total = res.Count
          this.tasks.data.forEach(item => {
            item.start_date = new Date(item.start_date)
          })
          gantt.parse(this.tasks)
          gantt.refreshData()
          gantt.render()
        })
      }
    },
    initGantt() {
      //自适应甘特图的尺寸大小, 使得在不出现滚动条的情况下, 显示全部任务
      gantt.config.autosize = true
      //只读模式
      gantt.config.readonly = true
      // 定义任务条上显示的内容，必须要在初始化 init 之前
      gantt.templates.task_text = function (start, end, task) {
        return `<div title="${task.desc}">任务名称：${task.desc}</div>`
      }

      // 指定 lightbox 的 header 部分
      gantt.templates.lightbox_header = function (start_date, end_date, task) {
        return `编辑 - ${task.text}`
        // return gantt.templates.task_time(task.start_date, task.end_date, task) + "&nbsp;" +
        //   (gantt.templates.task_text(task.start_date, task.end_date, task) || "").substr(0, 70);
      }

      // 初始化容器
      gantt.init(this.$refs.ganttContainer)

      gantt.config.virtual_rendering = true // 仅渲染可视区域（虚拟列表）
      gantt.config.duration_unit = 'day' // 任务持续时间的计算单位 "minute", "hour", "day", "week", "month", "year"

      // 时间轴与日期格式
      gantt.config.scale_unit = 'day' // "minute", "hour", "day", "week", "quarter", "month", "year"
      gantt.config.step = 1 // 单位间隔
      gantt.config.date_scale = '%Y年%m月%d号' // 日期显示格式
      // 在时间线上增加一行显示几号
      gantt.config.subscales = [
        {
          unit: 'hour',
          step: 2,
          date: '%H',
          css: date => {
            // 一个函数，返回应用于刻度单位的CSS类名。该函数接收一个日期对象作为参数
            var hour = date.getHours()
            if (hour >= 9 && hour <= 20) {
              return 'day-color'
            } else {
              return 'night-color'
            }
          }
        }
      ]

      gantt.config.min_column_width = 18 // 时间轴列的最小宽度

      // 任务条样式
      gantt.config.row_height = 40 // 行高
      gantt.config.bar_height = 20 // 任务条高度

      gantt.i18n.setLocale('cn') // 设置简体中文

      gantt.i18n.setLocale({
        labels: {
          new_task: '新任务',
          icon_save: '保存',
          icon_cancel: '取消',
          icon_details: '详情',
          icon_edit: '编辑',
          icon_delete: '删除',
          gantt_save_btn: '保存',
          gantt_cancel_btn: '取消',
          gantt_delete_btn: '编辑',
          confirm_closing: '您的更改将丢失，确定吗？',
          confirm_deleting: '任务将被永久删除，确定吗？',
          section_description: '描述',
          section_time: '时间周期',
          section_type: '类型',

          minutes: '分钟',
          hours: '小时',
          days: '天',
          weeks: '周',
          months: '月',
          years: '年',

          /* 消息弹窗 */
          message_ok: '确定',
          message_cancel: '取消'
        }
      })

      // 设置表格列，name为数据字段，label为表头显示的名称，width为列宽，align为对齐方式
      gantt.config.columns = [
           { name: 'text', label: '产品名称', min_width: 220, tree: true },
          { name: 'orderNo', label: '销售订单号', min_width: 100, align: 'center' },
          { name: 'workDocNo', label: '工单号', min_width: 100, align: 'center' },
          { name: 'StockInQuantity', label: '已入库数', min_width: 100, align: 'center' },
          { name: 'UnStockInQuantity', label: '未入库数', min_width: 100, align: 'center' }
        //{ name: 'text', label: '设备名称', width: '*', tree: true, max_width: 220 }
        // { name: "start_date", label: "开始时间", width: 90, align: "center" },
        // { name: "duration", label: "持续时间", width: 70, align: "center" },
        // { name: "unit", label: "单位", width: 50, align: "center" }, // 自定义字段数据
        // { name: "add", width: 40 }, // 添加按钮
      ]
      //设置任务条进度内容
      gantt.templates.progress_text = function (start, end, task) {
        return "<div style='text-align:left;color:#fff;padding-left:20px'>" + Math.round(task.progress * 100) + '% </div>'
      }
      /**
       * 数据格式：
       * text 任务名称。
       * start_date 任务开始日期
       * duration 任务持续时间
       * progress 任务的进度值（0 到 1 之间）
       * progressColor 设置任务进度条在时间轴中的颜色
       * unit 自定义字段，可以有多个自定义字段
       */
      var data = [
        {
          id: 1,
          text: 'A组',
          desc: '浸染',
          start_date: new Date('2025-08-07 00:00:00'),
          unit: '天',
          duration: 6,
          progress: 0.7,
          open: true
        },
        {
          id: 2,
          text: 'B组',
          desc: '裁剪',
          start_date: new Date('2025-08-09 00:00:00'),
          unit: '天',
          duration: 3,
          progress: 0.3
        },
        {
          id: 3,
          text: 'C组',
          desc: '机加工',
          start_date: new Date('2025-08-06 12:00:00'),
          unit: '天',
          duration: 2,
          progress: 0.9
        },
        {
          id: 4312,
          text: '调机',
          desc: '调机',
          start_date: new Date('2025-08-07 00:00:00'),
          unit: '天',
          duration: 2,
          progress: 1,
          parent: 1
        },
        {
          id: 5121,
          text: '加工',
          desc: '加工',
          start_date: new Date('2025-08-12 22:00:00'),
          unit: '天',
          duration: 4,
          progress: 0.6,
          parent: 1
        }
      ]

      const tasks = {
        data: data,
        links: [] // 任务依赖关系
      }
      gantt.parse(this.tasks) // 解析数据并渲染
    }
  }
}
</script>
<style lang="scss">
.gantt_grid_scale {
  .gantt_grid_head_cell + .gantt_grid_head_cell {
    border-left: 1px solid #cecece;
  }
}

.task-tools {
  margin: 10px 0;

  button {
    margin-right: 10px;
  }
}

.day-color {
  background-color: white;
}

.night-color {
  background-color: lightgray;
}
</style>